import React, { useState } from "react";
import { Check, Plus } from "lucide-react";

import ButtonV2 from "../../../components/ui/button/v2";
import CreateFraudElementsModal from "./createFraudElementModal";
import ConfirmModal from "../../../components/ui/modals/ConfirmModal";
import AIFraudElementsSidePeek from "./AIFraudElementsSidePeek";

interface GeneratedFraudElementsReadyStateProps {
  partyId: string;
}

const GeneratedFraudElementsReadyState: React.FC<
  GeneratedFraudElementsReadyStateProps
> = ({ partyId }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isCreateManuallySelected, setIsCreateManuallySelected] = useState(false);

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-7">
        <div className="flex flex-col items-center">
          <div className="flex h-8 items-center justify-center gap-2 px-4 py-1.5">
            <Check className="h-4 w-4 text-[#16A34A]" />

            <h3 className="text-base font-semibold leading-6 text-[#16A34A]">
              Fraud Elements are ready
            </h3>
          </div>

          <p className="max-w-[432px] text-center text-sm leading-5 text-[#737373]">
            The Canso AI agent has generated fraud elements applicable for the
            selected party. Please review and approve to save changes
          </p>
        </div>

        <div className="flex w-[432px] items-center justify-center gap-3">
          <ButtonV2
            variant="primary"
            size="md"
            onClick={() => setIsDrawerOpen(true)}
            className="h-9 rounded-[8px] bg-[linear-gradient(180deg,#788AF7_0%,#3551F3_100%)] px-3 text-[#FAFAFA]"
          >
            View Fraud Elements
          </ButtonV2>

          <ButtonV2
            variant="outline"
            size="md"
            onClick={() => setIsCreateManuallySelected(true)}
            prefix={<Plus className="h-4 w-4 text-[#0A0A0A]" />}
            className="h-9 rounded-[8px] border-[#E5E5E5] text-[#0A0A0A]"
          >
            Create Manually
          </ButtonV2>
        </div>
      </div>

      {isDrawerOpen && (
        <AIFraudElementsSidePeek
          partyId={partyId}
          onClose={() => setIsDrawerOpen(false)}
        />
      )}

      {isCreateManuallySelected && (
        <ConfirmModal
          title="Create Manually"
          description="If you create manually then the AI generated fraud elements will be lost"
          onCancel={() => setIsCreateManuallySelected(false)}
          onConfirm={() => {
            setIsCreateManuallySelected(false);
            setIsCreateModalOpen(true);
          }}
        />
      )}

      {isCreateModalOpen && (
        <CreateFraudElementsModal onClose={() => setIsCreateModalOpen(false)} />
      )}
    </>
  );
};

export default GeneratedFraudElementsReadyState;